module.exports = __webpack_public_path__ + "img/pk_curve_sm.6921bdb0.png";